import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ShopifyService } from 'src/app/service/shopify.service';

@Component({
    selector: 'app-qty',
    imports: [FormsModule, NgClass],
    templateUrl: './qty.component.html',
    styleUrl: './qty.component.scss'
})
export class QtyComponent {
  @Input() lineItem: any;
  _disabled: boolean = false;

  constructor(private shopifyService: ShopifyService) {}

  downOnce() {
    this._disabled = true;
    this.lineItem.quantity--;
    this.shopifyService
      .modifyLineItemQuantity([
        {
          id: this.lineItem.id,
          quantity: this.lineItem.quantity,
        },
      ])
      .subscribe((data) => {
        this._disabled = false;
      });
  }

  upOnce() {
    this._disabled = true;
    this.lineItem.quantity++;
    this.shopifyService
      .modifyLineItemQuantity([
        {
          id: this.lineItem.id,
          quantity: this.lineItem.quantity,
        },
      ])
      .subscribe((data) => {
        this._disabled = false;
      });
  }
}
